import { breakpoint as bp, sizes } from 'variables/breakpoint';

const breakpoint = {
    min(size) {
        return bp.min(sizes[size]);
    },

    max(size) {
        return bp.max(sizes[size]);
    },

    getNameFromWidth(width) {
        return bp.getNameFromWidth(width);
    },
    sizes
};

export default breakpoint;
